import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NextSDREntityProvider } from "@bds/next-sdr";
import { Albo, ENTITIES_STRUCTURE, getInternautaUrl, TipiTabellaAlbi } from "../../albi-constants";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PubblicazioniListService extends NextSDREntityProvider {
  constructor(
    protected _http: HttpClient,
    protected _datepipe: DatePipe
  ) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.albi.pubblicazioni, getInternautaUrl());
  }

  /**
   * Chiamata al backend per avere il tipo di registro ed il codice registro di una pubblicazione appartenente a una specifica azienda
   * e con l'albo di una specifica tipologia.
   * @param alboSelected
   * @returns
   */
  getRegistri(alboSelected: Albo): Observable<any[]> {
    try {
      let sottoTipologiaAlbo: string = "";
      if (alboSelected.specifica != null) {
        sottoTipologiaAlbo = alboSelected.specifica;
      }
      const tipologiaAlboRegistri =
        alboSelected.tipo === TipiTabellaAlbi.ALBO_TUTTE ? TipiTabellaAlbi.ALBO : alboSelected.tipo;
      const registriUrl =
        getInternautaUrl() +
        "/registri?azienda=" +
        alboSelected.azienda +
        "&tipologiaAlbo=" +
        tipologiaAlboRegistri +
        "&sottoTipologiaAlbo=" +
        sottoTipologiaAlbo;
      return this.http.get<any[]>(registriUrl);
    } catch (error) {
      console.log("Errore nel caricamento dei tipi di registro: ", error);
    }
  }
}
